import {Inject, injectable} from 'inversify-props';
import {TypedJSON} from 'typedjson';

import {CertificateGenerationParameters} from '@/model/system/certificate/certificateGenerationParameters';
import {CertificateIssuerDetails} from '@/model/system/certificate/certificateIssuerDetails';
import {CertificateDetails} from '@/model/system/certificate/certificateDetails';

import {IApiService} from '@/services/IApi.service';
import {ISystemCertificateService} from '@/services/system/ICertificate.service';

@injectable()
export class SystemCertificateService implements ISystemCertificateService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/system/certificate';

  private certificateDetailsSerializer = new TypedJSON(CertificateDetails);

  private certificateGenerationParameters = new TypedJSON(CertificateGenerationParameters);

  private certificateIssuerDetailsParameters = new TypedJSON(CertificateIssuerDetails);

  public async getDetails(): Promise<CertificateDetails> {
    return this.certificateDetailsSerializer.parse(await this.apiService.get(this.path))!;
  }

  public async upload(certificate: any, key: any, timeoutSec: number = 30): Promise<CertificateDetails> {

    const formData = new FormData();
    formData.append('certificate', certificate);
    formData.append('key', key);

    const config = {
      timeout: timeoutSec * 1000,
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    return this.certificateDetailsSerializer.parse(await this.apiService.post(`${this.path}/upload`, formData, config))!;
  }

  public async generate(parameters: CertificateGenerationParameters, issuerDetails: CertificateIssuerDetails, timeoutSec: number = 30): Promise<CertificateDetails> {

    const data = {
      parameters: this.certificateGenerationParameters.toPlainJson(parameters),
      issuerDetails: this.certificateIssuerDetailsParameters.toPlainJson(issuerDetails),
    };

    const config = {
      timeout: timeoutSec * 1000,
    };

    return this.certificateDetailsSerializer.parse(await this.apiService.post(`${this.path}/generate`, data, config))!;
  }
}
